import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 获取语言包
const getLangs = () => new Promise((resolve, reject) => {
    request({
        url: apis.common_all_langs
    }).then(res => {
        resolve(res);
    })
})

// 获取语言包
const getConfs = obj => new Promise((resolve, reject) => {
    const {
        tables,
    } = obj;
    request({
        url: apis.common_conf_find + '?tableNames=' + tables,
    }).then(res => {
        resolve(res);
    })
})

const findConfigurationByKey = obj => new Promise((resolve, reject) => {
    const {
        token,
        configurationKey
    } = obj;

    request({
        url: apis.common_configuration_find + '?token=' + token + '&configurationKey=' + configurationKey
    }).then(res => {
        resolve(res);
    })
});

// 查询阵容战力
const lineupCalculator = obj => new Promise((resolve, reject) => {
    const {
        lineupVO ,
        token
    } = obj;
    request({
        url: apis.common_conf_calc_lineup + '?token=' + token,
        data:lineupVO
    }).then(res => {
        resolve(res);
    })
})

export default {
    getLangs,
    getConfs,
    findConfigurationByKey,
    lineupCalculator
}



// WEBPACK FOOTER //
// ./src/service/common_api.js